import { API } from "@/lib/api";

function vid() {
  try {
    let v = localStorage.getItem("af_vid");
    if (!v) { v = (window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + Math.random()); localStorage.setItem("af_vid", v); }
    return v;
  } catch { return ""; }
}

function source() {
  try {
    const p = new URLSearchParams(window.location.search);
    if (p.get("utm_source")) return p.get("utm_source");
    const r = document.referrer || "";
    if (!r) return "direct";
    const h = new URL(r).hostname;
    if (h.includes(window.location.hostname)) return "direct";
    return h;
  } catch { return "direct"; }
}

export function track(event) {
  try {
    const p = new URLSearchParams(window.location.search);
    const body = JSON.stringify({
      event, visitor_id: vid(), source: source(),
      utm_source: p.get("utm_source") || undefined,
      utm_medium: p.get("utm_medium") || undefined,
      utm_campaign: p.get("utm_campaign") || undefined,
    });
    const url = `${API}/analytics/event`;
    if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    else fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch { /* analytics must never break the app */ }
}

export function trackPageOnce() {
  try {
    if (!sessionStorage.getItem("af_session")) { sessionStorage.setItem("af_session", "1"); track("unique_visit"); }
    track("page_view");
  } catch { /* ignore */ }
}
